<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Preface</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<div id="Preface">
<p class="chap-ttl"><a id="pxi"></a><a href="#/Table_of_contents"><span class="epub-bold-normal-normal">Preface</span></a></p>
<p class="chap-bm-first">Having published with SPCK and Eerdmans before, I was delighted and honoured to receive an invitation from Mr Philip Law of SPCK to write on Romans. In earlier years I had lectured on Romans as a set text, and the opportunity to update my work with reference to the half-dozen major commentaries which had appeared since then was more than appealing. I had produced commentaries on 1 Corinthians, 1 and 2 Thessalonians and Hebrews, but Romans presented an outstanding challenge to appreciate anew God’s purposes for world history, and for the daily life of the Christian.</p>
<p class="chap-bm">The series, Discovering Biblical Texts: Content, Interpretation, Reception, spoke at once to my immediate interests. In addition to discussing the content of Romans with students and writing on Paul,I had written twice on reception history, and produced six books on hermeneutics or interpretation. In Chapters 2 and 3 of the present book, I have set out 12 such methods. Three of them remain essential, and nine remain useful for limited purposes. Although this series is not designed for Greek specialists, some reference to Greek is indispensable for Romans. I have transliterated all Greek words into English letters, and carefully explained the meaning of those Greek words and occasionally syntax which are absolutely necessary for non-Greek readers.</p>
<p class="chap-bm">I have tried not to use a bewildering variety of names, but since this series requires an account of diverse views, I have included references to the most influential commentators. I have referred mainly, but not exclusively, to English-speaking writers. The names of Dunn, Cranfield, Fitzmyer, Wright and Jewett crop up so frequently that it would be pointless to index every reference. On the other hand many more, including Barrett, Nygren, Käsemann and Ziesler, are listed in the Index, together with others.</p>
<p class="chap-bm">Of all those to whom I owe a debt of gratitude, my wife, Rosemary, must come top of the list. She has typed virtually all of my handwriting, advised me when my style became obscure, and helped with the compiling of the index of modern authors. I am also grateful to Mr Philip Law of SPCK and Mr Jon Pott of Eerdmans for their encouragement.</p>
<p class="chap-right"><i>Anthony C. Thiselton, FBA Emeritus Professor of Christian Theology, University of Nottingham</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Preface.vue?3bcec43f